import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContextMenuPanelComponent } from './context-menu-panel.component';
import { ContextMenuDirective } from './context-menu.directive';
import {
      MatButtonModule,
      MatIconModule
} from '@angular/material';
import { ContextMenuService } from './context-menu.service';
export class HdContextMenuModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
      imports: [ CommonModule, MatButtonModule, MatIconModule ],
      declarations: [ ContextMenuPanelComponent, ContextMenuDirective ],
      exports: [ ContextMenuPanelComponent, ContextMenuDirective ],
      providers: [ContextMenuService],
      entryComponents: [ContextMenuPanelComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function HdContextMenuModule_tsickle_Closure_declarations() {
/** @type {?} */
HdContextMenuModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
HdContextMenuModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
